export const COLOR_TOOL_ACTIVE = "#2FB586"
export const COLOR_TOOL_IDLE = "#3148BF"
export const COLOR_PRIMARY = "#2FB586"
export const COLOR_DANGER = "#FC3B68"
export const COLOR_DARK = "#303744"
export const COLOR_GRAY = "#A19AC6"
export const COLOR_LIGHT = "#F9F9FF"
export const COLOR_HIGHLIGHTER = "#FFE499"
